import React from 'react';
import {Button} from 'reactstrap';
import * as Feather from 'react-feather';

export default function SidebarToggleButton({isSidebarCollapsed, toggleSidebar}) {
  const chevronClassName = isSidebarCollapsed ? 'is-collapsed' : 'is-not-collapsed';
  const screenReaderLabel = isSidebarCollapsed ? 'Expand Sidebar Navigation' : 'Collapse Sidebar Navigation';
  const Icon = Feather.Menu;
  return (
    <Button onClick={toggleSidebar} className={`m-r sidebar-toggle ${chevronClassName}`} aria-label={screenReaderLabel}>
      <Icon />
    </Button>
  );
}
